var _Circle, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 30,
    cy: 30,
    r: 28,
    stroke: "#F74249",
    strokeWidth: 4
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.523 14.97c-.777-1.294-2.654-1.294-3.43 0L13.288 39.646c-.8 1.333.16 3.03 1.715 3.03h29.61c1.554 0 2.514-1.697 1.714-3.03L31.523 14.971ZM27.84 24.47a1.927 1.927 0 1 1 3.849 0l-.311 5.608a1.615 1.615 0 0 1-3.226 0l-.312-5.608Zm3.453 10.7a1.528 1.528 0 1 1-3.057 0 1.528 1.528 0 0 1 3.057 0Z",
    fill: "#F74249"
  })));
};
export default SvgWarning;